import React, { useEffect, useState } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "../../../src/features/Inventory/Inventory.module.css"
import { ENDPOINTS } from "../../config";
import client from "../../services/client";
import { toast } from "react-toastify";
import { readFile } from "xlsx";
import { MdOutlineFileUpload } from "react-icons/md";
import ExcelReadTable from "../Inventory/ExcelReadTable";
import CommonSnackbar from "../../components/commonComponents/Snackbar/CommonSnackbar";
import { bulkUploadInventory } from "./Utility"; 
import * as XLSX from "xlsx";
const UploadExcel = ({
  open,
  setOpen,
  alertOpen,
  setAlertOpen,
  message,
  setMessage,
  statusColor,
  setStatusColor,
  handleAlertClose,
  moduleHeaders,
  inventoryValidationRules,
  setLoading,
  moduleName,
  fileSample,
  onUploadSuccess,
  tableData,
  setTableData,
  fetchSimInventory,
}) => {
  const [fileExtension, setFileExtension] = useState({
    type: ".csv",
    name: "CSV",
  });
  const [simType, setSimType] = useState("");
  const [validatedData, setValidatedData] = useState([]);
  const [checkExcelError, setCheckExcelError] = useState(false);
  const [excelColumns, setExcelColumns] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const navigate = useNavigate();

  const handleClose = () => {
    setValidatedData([]);
    setSelectedFile(null);
    setOpen(false);
    setSimType("");
    setCheckExcelError(false);
    setMessage("");
    setStatusColor("");
   
    const fileInput = document.getElementById("file-upload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleUploadInventory = async () => {
    if (!selectedFile) {
      setStatusColor("error");
      setMessage("Please select a file to upload.");
      setAlertOpen(true);
      return;
    }

    try {
      setLoading(true);
        if (fetchSimInventory) {
          await fetchSimInventory(selectedFile, simType);
        }
        setStatusColor("success");
        setMessage(`Successfully uploaded `);
        setAlertOpen(true);
        handleClose(); 
      } 
     catch (error) {
      console.error("Error uploading inventory:", error);
      setStatusColor("error");
      setMessage(error.message || "Failed to upload file.");
      setAlertOpen(true);
      toast.error(error.message || "Failed to upload file.");
    } finally {
      setLoading(false);
    }
  };

  const fileInputHandler = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setSelectedFile(null);
      setValidatedData([]);
      setCheckExcelError(false);
      return;
    }

    setSelectedFile(file);
    const fileType = file.name.split(".").pop();
    setValidatedData([]);
    setCheckExcelError(false);
    setMessage("");
    setStatusColor("");
    handleFileValidation(file, `.${fileType}`);
  };

  const handleFileValidation = async (file) => {
    try {
      const reader = new FileReader();
  
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
        if (jsonData.length === 0) {
          setStatusColor("error");
          setMessage("File is empty or invalid.");
          setAlertOpen(true);
          setCheckExcelError(true);
          setSelectedFile(null);
          return;
        }
        const fileHeaders = Object.keys(jsonData[0]).map((h) =>
          h.toLowerCase().trim()
        );
        const requiredHeaders = ["iccid"];
        const missingHeaders = requiredHeaders.filter(
          (h) => !fileHeaders.includes(h)
        );
  
        if (missingHeaders.length > 0) {
          setStatusColor("error");
          setMessage(
            `Missing required columns: ${missingHeaders.join(", ")}. Expected columns: ICCID, IMSI, MSISDN`
          );
          setAlertOpen(true);
          setCheckExcelError(true);
          setSelectedFile(null);
          return;
        }
  
        // Preview data
        const previewData = jsonData.map((row, index) => ({
          serial: index + 1,
          iccid: row.ICCID || row.iccid || "",
          imsi: row.IMSI || row.imsi || "",
          msisdn: row.MSISDN || row.msisdn || "",
        }));
  
        setExcelColumns([
          // { key: "serial", label: "Sr. No" },
          { key: "iccid", label: "ICCID" },
          // { key: "imsi", label: "IMSI" },
          // { key: "msisdn", label: "MSISDN" },
        ]);
  
        setValidatedData(previewData);
        setCheckExcelError(false);
        setStatusColor("success");
        setMessage(
          `File validated successfully. ${jsonData.length} records ready for upload.`
        );
        setAlertOpen(true);
      };
  
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Error reading file:", error);
      setStatusColor("error");
      setMessage(`Failed to read file: ${error.message}`);
      setAlertOpen(true);
      setCheckExcelError(true);
      setSelectedFile(null);
    }
  };
  

  return (
    <Dialog
      open={open}
      className={styles.assignContainer}
      maxWidth={validatedData?.length > 0 ? "lg" : "sm"}
      fullWidth
    >
      <DialogTitle className="modalThemeColor">
        <Typography variant="h6">{moduleName}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="h6" gutterBottom>
          {`${fileExtension?.name} Bulk Upload`}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              Upload Type <span style={{ color: "red" }}>*</span>
            </Typography>
            <Autocomplete
              size="small"
              options={[
                { type: ".csv", name: "CSV" },
                { type: ".xlsx", name: "Excel" },
              ]}
              getOptionLabel={(option) => option.name || ""}
              value={fileExtension}
              onChange={(e, newValue) => {
                setValidatedData([]);
                setCheckExcelError(false);
                setSelectedFile(null);
                setFileExtension(newValue);
                setMessage("");
                setStatusColor("");
                const fileInput = document.getElementById("file-upload");
                if (fileInput) {
                  fileInput.value = "";
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Upload Type"
                  variant="outlined"
                />
              )}
              style={{ marginBottom: 16 }}
            />
          </Grid>

         

          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              File Selection:{" "}
              <a href={fileSample} download className={styles.downloadLink}>
                ({`Download Sample ${fileExtension?.name}`})
              </a>
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Required columns: ICCID
            </Typography>
            <div className={styles.fileInputContainer}>
              <input
                type="file"
                disabled={!fileExtension?.type}
                accept={fileExtension?.type}
                id="file-upload"
                style={{ display: "none" }}
                onChange={fileInputHandler}
              />
              <label htmlFor="file-upload" className={styles.fileInputLabel}>
                <Typography
                  variant="body1"
                  component="span"
                  className={styles.fileInputText}
                >
                  {selectedFile 
                    ? selectedFile.name 
                    : fileExtension?.type
                    ? "No File Chosen"
                    : "Please Select Upload Type"
                  }
                </Typography>
              </label>
              <MdOutlineFileUpload className={styles.downloadIcon} />
            </div>
          </Grid>

          {/* Preview table - only show if we have validated data */}
          {validatedData.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                File Preview ({validatedData.length} records)
              </Typography>
              <ExcelReadTable
                validatedData={validatedData}
                excelColumns={excelColumns}
                fileExtension={fileExtension}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={handleClose}
          variant="outlined"
          size="large"
        >
          Close
        </Button>
        <Button
          disabled={checkExcelError || !selectedFile }
          color="success"
          onClick={handleUploadInventory}
          variant="contained"
          size="large"
        >
          Upload ({validatedData.length} records)
        </Button>
      </DialogActions>
      <CommonSnackbar
        open={alertOpen}
        message={message}
        handleClose={handleAlertClose}
        status={statusColor}
        setOpen={setAlertOpen}
      />
    </Dialog>
  );
};

export default UploadExcel;